import { UpsertStripeCustomerMutation } from "src/api/Stripe";
import { StripeToken } from "src/models/UserModel";
import { apiClient } from "src/stores/Api";
import { upsertStripeCustomerVariables } from "types/code-generator";

interface CreateStripeCustomerInput {
  userId: string;
  stripeToken: StripeToken;
  organizationId: string;
}

export default ({
  userId,
  stripeToken,
  organizationId,
}: CreateStripeCustomerInput) => {
  const variables: upsertStripeCustomerVariables = {
    data: {
      userId,
      stripeToken,
      organizationId,
    },
  };

  return apiClient(UpsertStripeCustomerMutation, {
    variables,
  });
};
